<template>
    <div class="swiperImg">
        <el-carousel trigger="click" height="510px" :interval="slideshowTime" :loop="true" arrow="never">
            <el-carousel-item v-for="(item, index) in swiperList" :key="index">
                <img :src="$imgUrl + item.ads_img" alt="" v-if="item.ads_img.indexOf('http') == -1">
                <img :src="item.ads_img" alt="" v-else>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    data(){
        return {
            swiperList:[],
            slideshowTime:10000,
        }
    },
    mounted(){
        this.getSwiper()
    },
    methods:{
        // 获取轮播图片
        async getSwiper(){
            let res = await this.$axios.post("/lencon/pc/index/banner", { type: 26 })
            if(res.data.code == 1){
                this.swiperList = res.data.res
                this.slideshowTime = res.data.slideshowTime || 10000
            }
        }
    }
}
</script>

<style lang="scss">
.swiperImg{
    margin-top: -18px;
    position: relative;
}

.el-carousel__indicators--horizontal{
    bottom: 50px !important;
}

.el-carousel__indicator{
    margin: 0 5px;
}

.is-active .el-carousel__button{
    width: 67px;
    height: 10px;
    background: #FFFFFF;
    box-shadow: 0px 3px 10px 0px rgba(84,104,119,0.35);
    border-radius: 5px;
}

.el-carousel__button{
    width: 10px;
    height: 10px;
    background: #FFFFFF;
    border-radius: 50%;
    padding: 0;
    opacity: 1;
}

.el-carousel__item img{
    width: 100%;
    height: 510px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}
</style>